//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Tabs } from 'vant'
import CSlot from '@/components/CSlot'

export default {
  name: 'CTabs',

  components: {
    ITabs: Tabs,
    CSlot,
  },

  inheritAttrs: false,

  props: {
    ...Tabs.props,
    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },
  },

  data () {
    return { innerActive: '' }
  },

  methods: {
    handlerChange (val, title) {
      this.innerActive = val

      this.$emit('input', val)
      this.$emit('change', val, title)
    },
  },
}
